<template>
    <div class="dashboard">
        <v-main>
            <v-container>
                <top-search-bar :mobile_number="mobile_number" :logo="logo" />
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12" class="mb-3">
                            <p class="heading">Product Details</p>
                            <hr>
                        </v-col>
                        <v-col cols="12">
                            <label class="subheading" for="">Product Name
                                <span class="mandatory">*</span>
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field v-model="$v.product_name.$model" outlined label="" placeholder="Product Name"
                                required>
                            </v-text-field>

                            <div v-if="$v.product_name.$dirty" style="margin-top:-20px !important">
                                <span class="red--text" v-if="!$v.product_name.required"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                    required</span>
                            </div>
                        </v-col>
                        <v-col cols="12" v-if="product_categories_input">
                            <label class="subheading" for="">Select Category
                                <span class="mandatory">*</span>
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-select outlined label="" v-model="$v.product_category.$model"
                                :items="this.product_categories">
                            </v-select>
                            <div v-if="$v.product_category.$dirty" style="margin-top:-20px !important">
                                <span class="red--text" v-if="!$v.product_category.required"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                    required</span>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12" v-if="product_code_preference">
                            <label class="subheading" for="">HSN/SAC Code
                                <span class="mandatory">*</span>
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field v-model="$v.hsn_sac_code.$model" outlined label="" placeholder="HSN/SAC Code">
                            </v-text-field>
                            <div v-if="$v.hsn_sac_code.$dirty" style="margin-top:-20px !important">
                                <span class="red--text" v-if="!$v.hsn_sac_code.required"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                    required</span>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12" v-if="product_sku_preference">
                            <label class="subheading" for="">Item Code/ SKU
                                <span class="mandatory">*</span>
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field v-model="$v.sku_item_code.$model" outlined label=""
                                placeholder="SKU/Item Code">
                            </v-text-field>
                            <div v-if="$v.sku_item_code.$dirty" style="margin-top:-20px !important">
                                <span class="red--text" v-if="!$v.sku_item_code.required"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                    required</span>
                            </div>
                        </v-col>
                        <!-- <v-col cols="12"  v-if="product_units_preference">
                            <v-select outlined label="Select Unit*" v-model="$v.product_unit.$model"
                                :items="this.units">
                            </v-select>
                            <div v-if="$v.product_unit.$dirty" style="margin-top:-20px !important">
                                <span class="red--text" v-if="!$v.product_unit.required"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                    required</span>
                            </div>
                        </v-col> -->

                        <v-col cols="12" v-if="product_units_preference">
                            <v-row>
                                <v-col cols="4">
                                    <unitList v-model="showUnitList" :units="units" :baseUnit="base_unit"
                                        :secondaryUnit="secondary_unit" :secondaryValue="secondary_unit_value"
                                        @passUnits="getSelectedUnit" />
                                    <v-btn block @click="showUnitList=true" color="primary">Select Unit</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <!-- <v-col cols="12" lg="6" md="6" sm="12">
                            <v-text-field v-model="secondary_unit" outlined label="Secondary Unit"
                                placeholder="Secondary Unit" readonly>
                            </v-text-field>
                        </v-col> -->

                        <v-col cols="12" lg="4" md="6" sm="12" v-if="opening_stock">
                            <label class="subheading" for="">Quantity
                                <span class="mandatory">*</span>
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field outlined v-model="$v.quantity.$model" label="" placeholder="Quantity">
                            </v-text-field>
                            <div v-if="$v.quantity.$dirty" style="margin-top:-20px !important">
                                <span class="red--text" v-if="!$v.quantity.required"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                    required</span>
                                <span class="red--text" v-if="!$v.quantity.numeric"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i>Quantity
                                    must be numeric</span>
                            </div>
                        </v-col>

                        <v-col cols="12" lg="4" md="6" sm="12" v-if="opening_stock">
                            <label class="subheading" for="">Free (Optional)
                                <!-- <span style="color:red">*</span> -->
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field outlined v-model="free" @change="findNumber" label="" placeholder="Free">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" lg="4" md="6" sm="12" v-if="opening_stock">
                            <label class="subheading" for="">Batch No.(Optional)
                                <!-- <span style="color:red">*</span> -->
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field outlined v-model="batch_no" label="" placeholder="Batch">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" v-if="!opening_stock">
                            <label class="subheading" for="">Product is available ?
                                <span style="color:red">*</span>
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <label class="subheading" for="">Product is available ?</label>
                            <v-radio-group v-model="product_availability" row>
                                <v-radio label="Yes" value="yes"></v-radio>
                                <v-radio label="No" value="no"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12">
                            <v-row>

                                <v-col cols="12" lg="6" md="6" sm="12" v-if="manufacturing_date_preference">
                                    <label class="subheading" for="">Manufacturing Date(Optional)
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <v-text-field outlined v-model="manufacturing_date" type="date" label=""
                                        placeholder="Manufacturing Date">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" lg="6" md="6" sm="12" v-if="expiry_date_preference">
                                    <label class="subheading" for="">Expiry Date(Optional)
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <v-text-field outlined v-model="expiry_date" type="date" label=""
                                        placeholder="Expiry Date">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>


                        <v-col cols="12" lg="6" md="6" sm="12">
                            <label class="subheading" for="">Minimum Stock Alert
                                <span class="mandatory">*</span>
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field v-model="$v.minimum_stock_alert.$model" outlined label=""
                                placeholder="Minimum Stock Alert" required>
                            </v-text-field>
                            <div v-if="$v.minimum_stock_alert.$dirty" style="margin-top:-20px !important">
                                <span class="red--text" v-if="!$v.minimum_stock_alert.required"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                    required</span>
                                <span class="red--text" v-if="!$v.minimum_stock_alert.numeric"><i
                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i>Minimum Stock Alert
                                    must be numeric</span>
                            </div>
                        </v-col>

                        <v-col cols="12" lg="6" md="6" sm="12">
                            <label class="subheading" for="">Location (Optional)
                                <!-- <span style="color:red">*</span> -->
                                <v-tooltip v-model="show" top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                mdi-information
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Programmatic tooltip</span>
                                </v-tooltip>
                            </label>
                            <v-text-field outlined v-model="location" label="" placeholder="Location">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" v-if="barcode">
                            <v-row>
                                <v-col cols="4" lg="4" md="6" sm="12" class="pt-14">
                                    <BarcodeScanner v-model="showBarcodeScanner"
                                        @passBarcodeNumber="getBarcodeNumber" />
                                    <v-btn @click="showScanner" variant="outlined"
                                        v-if="showInputForBarcodeNumber==false" block color="primary">
                                        Barcode
                                    </v-btn>
                                </v-col>
                                <!-- <v-col cols="2"></v-col> -->
                            </v-row>
                            <v-row>
                                <v-col cols="4" lg="4" md="6" sm="12" v-if="showInputForBarcodeNumber==true">
                                    <label class="subheading" for="">Barcode Number
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <v-text-field outlined v-model="barcodeNumber" label="" placeholder=""
                                        @focus="showScanner">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12" class="mb-3">
                                    <p class="heading">Price Details</p>
                                    <hr>
                                </v-col>
                                <v-col cols="12" lg="6" md="6" sm="12">
                                    <label class="subheading" for="">MRP
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <v-text-field prefix="₹" v-model="$v.product_mrp.$model" outlined label=""
                                        placeholder="MRP">
                                    </v-text-field>
                                    <div v-if="$v.product_mrp.$dirty" style="margin-top:-20px !important">
                                        <!-- <span class="red--text" v-if="!$v.product_mrp.required"><i
                                                class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                            required</span> -->
                                        <span class="red--text" v-if="!$v.product_mrp.decimal"><i
                                                class="fa fa-exclamation-triangle" aria-hidden="true"></i>Product MRP
                                            Name must
                                            be number</span>
                                    </div>
                                </v-col>
                                <v-col cols="12" lg="6" md="6" sm="12">
                                    <label class="subheading" for="">Unit
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <!-- <v-text-field v-model="base_unit" outlined label="" placeholder="Base Unit"
                                        readonly>
                                    </v-text-field> -->
                                    <p class="py-3">1 {{this.base_unit }}</p>
                                </v-col>

                                <v-col cols="12">
                                    <v-row>
                                        <v-col lg="6" md="6" sm="12" cols="12">
                                            <v-row>
                                                <v-col cols="6">
                                                    <label class="subheading" for="">Sale Price
                                                        <span class="mandatory">*</span>
                                                        <v-tooltip v-model="show" top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1"
                                                                        style="font-size:18px">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </label>
                                                    <v-text-field prefix="₹" v-model="$v.sale_price.$model" outlined
                                                        label="" placeholder="Sale Price">
                                                    </v-text-field>
                                                    <div v-if="$v.sale_price.$dirty"
                                                        style="margin-top:-20px !important">
                                                        <span class="red--text" v-if="!$v.sale_price.required"><i
                                                                class="fa fa-exclamation-triangle"
                                                                aria-hidden="true"></i> The
                                                            field is
                                                            required</span>
                                                        <span class="red--text" v-if="!$v.sale_price.decimal"><i
                                                                class="fa fa-exclamation-triangle"
                                                                aria-hidden="true"></i>Sale
                                                            Price
                                                            must be number</span>
                                                    </div>
                                                </v-col>
                                                <v-col cols="6">
                                                    <label class="subheading" for="">Select Tax Type
                                                        <!-- <span style="color:red">*</span> -->
                                                        <v-tooltip v-model="show" top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1"
                                                                        style="font-size:18px">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </label>
                                                    <v-select v-model="$v.tax_type.$model" outlined label=""
                                                        :items="['Excluding Tax','Including Tax']">
                                                    </v-select>
                                                    <div v-if="$v.tax_type.$dirty" style="margin-top:-20px !important">
                                                        <span class="red--text" v-if="!$v.tax_type.required"><i
                                                                class="fa fa-exclamation-triangle"
                                                                aria-hidden="true"></i> The
                                                            field is
                                                            required</span>
                                                    </div>
                                                </v-col>

                                            </v-row>
                                        </v-col>
                                        <v-col lg="6" md="6" sm="12" cols="12" v-if="product_mrp_preference">
                                            <v-row>
                                                <v-col cols="6">
                                                    <label class="subheading" for="">Purchase Price
                                                        <span class="mandatory">*</span>
                                                        <v-tooltip v-model="show" top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1"
                                                                        style="font-size:18px">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </label>
                                                    <v-text-field prefix="₹" v-model="$v.purchase_price.$model" outlined
                                                        label="" placeholder="Purchase Price"
                                                        @change="checkPurchasePrice"
                                                        @foucs="checkPurchasePrice"
                                                        >
                                                    </v-text-field>
                                                    <div v-if="$v.purchase_price.$dirty"
                                                        style="margin-top:-20px !important">
                                                        <span class="red--text" v-if="!$v.purchase_price.required"><i
                                                                class="fa fa-exclamation-triangle"
                                                                aria-hidden="true"></i> The
                                                            field is
                                                            required</span>
                                                        <span class="red--text" v-if="!$v.purchase_price.decimal"><i
                                                                class="fa fa-exclamation-triangle"
                                                                aria-hidden="true"></i>Purchase
                                                            Price
                                                            must be number</span>
                                                    </div>
                                                </v-col>
                                                <v-col cols="6">
                                                    <label class="subheading" for="">Select Tax Type
                                                        <!-- <span style="color:red">*</span> -->
                                                        <v-tooltip v-model="show" top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon color="grey lighten-1"
                                                                        style="font-size:18px">
                                                                        mdi-information
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Programmatic tooltip</span>
                                                        </v-tooltip>
                                                    </label>
                                                    <v-select v-model="$v.purchase_tax_type.$model" outlined label=""
                                                        :items="['Excluding Tax','Including Tax']">
                                                    </v-select>
                                                    <div v-if="$v.purchase_tax_type.$dirty"
                                                        style="margin-top:-20px !important">
                                                        <span class="red--text" v-if="!$v.purchase_tax_type.required"><i
                                                                class="fa fa-exclamation-triangle"
                                                                aria-hidden="true"></i> The
                                                            field is
                                                            required</span>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-col lg="6" md="6" sm="12" cols="6">
                                    <label class="subheading" for="">Tax
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <v-select outlined label="" v-model="$v.tax_percentage.$model"
                                        :items="this.taxesFromPreferences" @change="salePriceCalculator">
                                    </v-select>
                                    <div v-if="$v.tax_percentage.$dirty">
                                        <span class="red--text" v-if="!$v.tax_percentage.required"><i
                                                class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                            required</span>
                                    </div>
                                    <div v-if="salePriceWithoutTax!=0 && taxAmount!=0">
                                        Final Price = Rs. {{ salePriceWithoutTax }} + Rs. {{ taxAmount }} = Rs.
                                        {{ this.final_price }}
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <v-row>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                            <label class="subheading" for="">Discount Type
                                                <!-- <span style="color:red">*</span> -->
                                                <v-tooltip v-model="show" top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-bind="attrs" v-on="on">
                                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                                mdi-information
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Programmatic tooltip</span>
                                                </v-tooltip>
                                            </label>
                                            <v-select v-model="$v.discount_type.$model" outlined label=""
                                                :items="['Percentage','Amount']">
                                            </v-select>
                                            <div v-if="$v.discount_type.$dirty" style="margin-top:-20px !important">
                                                <span class="red--text" v-if="!$v.discount_type.required"><i
                                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The
                                                    field is
                                                    required</span>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                            <label class="subheading" for="">Discount on Sale Price
                                                <!-- <span style="color:red">*</span> -->
                                                <v-tooltip v-model="show" top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-bind="attrs" v-on="on">
                                                            <v-icon color="grey lighten-1" style="font-size:18px">
                                                                mdi-information
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Programmatic tooltip</span>
                                                </v-tooltip>
                                            </label>
                                            <v-text-field prefix="₹" v-model="$v.discount_amount.$model" type="number"
                                                :min="minValue" :max="maxValue" outlined label=""
                                                placeholder="Discount on Sale Price" required>
                                            </v-text-field>
                                            <div v-if="$v.discount_amount.$dirty" style="margin-top:-20px !important">
                                                <span class="red--text" v-if="!$v.discount_amount.required"><i
                                                        class="fa fa-exclamation-triangle" aria-hidden="true"></i> The
                                                    field is
                                                    required</span>
                                                <span class="red--text" v-if="!$v.discount_amount.decimal"><i
                                                        class="fa fa-exclamation-triangle"
                                                        aria-hidden="true"></i>Discount Amount must
                                                    be number</span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" lg="6" md="6" sm="12">
                                    <label class="subheading" for="">Minimum order quantity
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <v-text-field outlined v-model="$v.minimum_order_quantity.$model" label=""
                                        placeholder="Minimum order quantity">
                                    </v-text-field>
                                    <div v-if="$v.minimum_order_quantity.$dirty" style="margin-top:-20px !important">
                                        <span class="red--text" v-if="!$v.minimum_order_quantity.numeric"><i
                                                class="fa fa-exclamation-triangle" aria-hidden="true"></i>Quantity
                                            must be numeric</span>
                                    </div>
                                </v-col>

                            </v-row>
                        </v-col>

                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12" class="mb-3">
                                    <p class="heading">Product Description</p>
                                    <hr>
                                </v-col>
                                <v-col cols="12">
                                    <label class="subheading" for="">Product Description(Optional)
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <v-textarea outlined name="input-7-4" v-model="$v.product_description.$model"
                                        label="" placeholder="You can add general product description">
                                    </v-textarea>
                                    <!-- <div v-if="$v.product_description.$dirty" style="margin-top:-20px !important">
                                        <span class="red--text" v-if="!$v.product_description.required"><i
                                                class="fa fa-exclamation-triangle" aria-hidden="true"></i> The field is
                                            required</span>

                                    </div> -->
                                </v-col>
                                <v-col cols="12">
                                    <!-- <label for="">Upload your product photo(s)</label> -->
                                    <label class="subheading" for="">Upload your product photo(s)
                                        <!-- <span style="color:red">*</span> -->
                                        <v-tooltip v-model="show" top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="grey lighten-1" style="font-size:18px">
                                                        mdi-information
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Programmatic tooltip</span>
                                        </v-tooltip>
                                    </label>
                                    <div>
                                        <span class="error--text">Only 5 images are allow to uploaded. Allowed image
                                            formats are jpg, jpeg, png, bmp,gif and Maximum file
                                            size is 20 MB</span> </div>

                                    <image-gallery @onImageSelected="onImageSelected($event)" />
                                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                        @vdropzone-complete="afterComplete"></vue-dropzone>
                                </v-col>

                            </v-row>
                        </v-col>


                        <v-col cols="12" lg="6" md="6" sm="12">
                            <ProductPreview v-model="showPreviewProduct" />
                            <v-btn color="" @click="previewProduct">Preview</v-btn>
                        </v-col>
                        <v-col cols="12" lg="6" md="6" sm="12" class="d-flex justify-end">
                            <!-- <v-btn variant="outlined" v-show="save_btn" text :disabled="!valid" >Save
                            </v-btn>
                            <v-btn variant="outlined" v-show="update_btn" text :disabled="!valid" @click="validate">
                                Update
                            </v-btn> -->
                            <v-btn type="submit" class="mt-2">Submit</v-btn>
                        </v-col>



                    </v-row>
                </v-form>
            </v-container>
        </v-main>
        <Footer />
    </div>
</template>

<script>
    import Footer from '@/components/Footer.vue'
    import ProductPreview from '@/components/ProductPreview.vue'
    import TopSearchBar from '@/components/TopSearchBar.vue'
    import vueDropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ImageGallery from '@/components/ImageGallery.vue'
    import unitList from '@/components/unitList'
    import BarcodeScanner from '@/components/barcode'
    import {
        required,
        requiredIf,
        decimal,
        numeric
    } from 'vuelidate/lib/validators';

    export default {
        name: 'AddProduct',
        components: {
            ProductPreview,
            Footer,
            TopSearchBar,
            vueDropzone,
            ImageGallery,
            unitList,
            BarcodeScanner
        },
        data() {
            return {
                showPreviewProduct: false,
                selected_images: [],
                business_name: null,
                unit_inputbox_length: 2,
                mrp_inputbox_length: 1,
                rate_inputbox_length: 1,
                moq_inputbox_length: 1,
                title: 'Add Product',
                product_code_disabled: false,
                save_btn: true,
                update_btn: false,
                valid: true,
                mobile_number: null,
                logo: null,
                product_categories: [],
                product_category: null,
                product_sub_categories: [],
                product_sub_category: null,
                product_sub_categories_input: false,
                product_code: null,
                product_name: null,
                product_description: null,
                is_taxable: 'no',
                is_item_grouped: 'yes',
                add_unit_input: true,
                tax: 0,
                tax_input: false,
                dropzoneOptions: {
                    url: 'https://httpbin.org/post',
                    maxFiles: 5,
                    maxFilesize: 20,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpeg,.jpg,.png,.gif,.bmp",
                    uploadMultiple: false
                },
                options_yes_no: ['yes', 'no'],
                search: null,
                sub_category_input_val: null,
                product: {
                    unit: '',
                    code: '',
                    mrp: '',
                    rate: '',
                    moq: 1,
                    available: 'yes',
                    stock: ''
                },
                products: [],
                product_code_preference: true,
                product_sku_preference: true,
                product_mrp_preference: true,
                product_rate_preference: true,
                product_stock_preference: 'yes',
                product_categories_input: false,
                product_units_preference: false,
                product_images: [],
                uploaded_product_images: [],
                units: [],
                opening_stock: true,
                barcode: true,
                minValue: 0,
                maxValue: null,
                discount_value_visible: false,

                product_unit: '',
                hsn_sac_code: null,
                sku_item_code: null,
                product_mrp: null,
                sale_price: null,
                tax_type: 'Excluding Tax',
                tax_percentage: 'None',
                purchase_price: null,
                discount_type: 'Percentage',
                discount_amount: 0,
                stock: null,
                minimum_stock_alert: null,
                minimum_order_quantity: null,
                showUnitList: false,
                base_unit: 'None',
                secondary_unit: 'None',
                secondary_unit_value: 0,
                quantity: null,
                free: null,
                batch_no: null,
                manufacturing_date: null,
                expiry_date: null,
                location: null,
                purchase_tax_type: 'Excluding Tax',
                manufacturing_date_preference: true,
                expiry_date_preference: true,
                product_availability: null,
                freeQuantity: [],
                totalFreeQuantity: 0,
                showBarcodeScanner: false,
                barcodeNumber: null,
                salePriceWithoutTax: 0,
                taxAmount: 0,
                final_price: 0,
                taxesFromPreferences: [],
                showInputForBarcodeNumber: false,
            }
        },
        validations: {
            product_name: {
                required,
            },
            product_category: {
                required: requiredIf(function () {
                    return this.product_categories_input;
                }),
            },
            // product_unit: {
            //     required: requiredIf(function () {
            //         return this.product_units_preference;
            //     }),
            // },
            hsn_sac_code: {
                required: requiredIf(function () {
                    return this.product_code_preference;
                }),
            },
            sku_item_code: {
                required: requiredIf(function () {
                    return this.product_sku_preference;
                }),
            },
            quantity: {
                required: requiredIf(function () {
                    return this.opening_stock;
                }),
                numeric
            },
            product_mrp: {
                // required,
                decimal
            },
            sale_price: {
                // required: requiredIf(function () {
                //     return this.product_rate_preference;
                // }),
                required,
                decimal
            },
            tax_type: {
                // required: requiredIf(function () {
                //     return this.product_rate_preference;
                // }),
                required
            },
            purchase_tax_type: {
                required: requiredIf(function () {
                    return this.product_mrp_preference;
                }),
            },
            tax_percentage: {
                required,
            },
            purchase_price: {
                required: requiredIf(function () {
                    return this.product_mrp_preference;
                }),
                decimal
            },
            discount_type: {
                required,
            },
            discount_amount: {
                required: requiredIf(function () {
                    return this.discount_value_visible;
                }),
                decimal
            },
            // stock: {
            //     required: requiredIf(function () {
            //         return this.opening_stock;
            //     }),
            //     numeric
            // },
            minimum_stock_alert: {
                required,
                numeric
            },
            minimum_order_quantity: {
                // required,
                numeric
            },
            product_description: {
                // required,
            },
        },
        computed: {

        },
        methods: {
            // validate() {
            //     if (this.$refs.form.validate()) {
            //         if (this.$route.params.id)
            //             this.updateProduct()
            //         else
            //             this.saveProduct()
            //     }
            // },
            // validateAddNewInventory(){
            //     this.saveProduct()
            // },
            submit() {
                this.$v.$touch();
                if (this.$v.$error) return

                if (this.$route.params.id) {
                    this.updateProduct()
                } else {
                    this.saveProduct()
                }
            },
            previewProduct() {
                // this.product_images.splice(0, 1);
                console.log("product image", this.product_images.length)
                let data = {
                    // category: this.product_category,
                    // sub_category: this.product_sub_category,
                    // name: this.product_name,
                    // description: this.product_description,
                    // tax: this.tax,
                    // product: this.products,
                    // product_images: this.product_images,
                    // uploaded_product_images: this.uploaded_product_images,

                    // name: this.product_name,
                    // category: this.product_category,
                    // unit: this.product_unit,
                    // hsn_sac_code: this.hsn_sac_code,
                    // sku_item_code: this.sku_item_code,
                    // mrp: this.product_mrp,
                    // sale_price: this.sale_price,
                    // tax_type: this.tax_type,
                    // tax_percentage: this.tax_percentage,
                    // purchase_price: this.purchase_price,
                    // discount_type: this.discount_type,
                    // discount_amount: this.discount_amount,
                    // stock: this.stock,
                    // minimum_stock_alert: this.minimum_stock_alert,
                    // minimum_order_quantity: this.minimum_order_quantity,
                    // description: this.product_description,
                    // product_images: this.product_images,
                    // uploaded_product_images: this.uploaded_product_images,

                    name: this.product_name,
                    category: this.product_category,
                    hsn_sac_code: this.hsn_sac_code,
                    sku_item_code: this.sku_item_code,
                    base_unit: this.base_unit,
                    secondary_unit: this.secondary_unit,
                    quantity: this.quantity,
                    free: this.free,
                    batch_no: this.batch_no,
                    product_availability: this.product_availability,
                    manufacturing_date: this.manufacturing_date,
                    expiry_date: this.expiry_date,
                    minimum_stock_alert: this.minimum_stock_alert,
                    location: this.location,
                    mrp: this.product_mrp,
                    sale_price: this.sale_price,
                    tax_type: this.tax_type,
                    purchase_price: this.purchase_price,
                    purchase_tax_type: this.purchase_tax_type,
                    tax_percentage: this.tax_percentage,
                    discount_type: this.discount_type,
                    discount_amount: this.discount_amount,
                    minimum_order_quantity: this.minimum_order_quantity,
                    description: this.product_description,
                    product_images: this.product_images,
                    uploaded_product_images: this.uploaded_product_images,
                    secondary_unit_value: this.secondary_unit_value,

                }
                console.log("product_images", this.product_images)
                console.log("uploaded_product_images", this.uploaded_product_images)

                this.$store.dispatch('previewProduct', data)
                    .then(() => {
                        this.showPreviewProduct = true
                    })
                    .catch(err => {
                        // console.log(err)
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: err,
                        });
                    })
            },
            saveProduct() {
                let data = {
                    // category: this.product_category,
                    // sub_category: this.product_sub_category,
                    // name: this.product_name,
                    // description: this.product_description,
                    // tax: this.tax,
                    // is_item_grouped: this.is_item_grouped,
                    // product: this.products,
                    // product_images: this.product_images,
                    // selected_images: this.selected_images
                    name: this.product_name,
                    category: this.product_category,
                    hsn_sac_code: this.hsn_sac_code,
                    sku_item_code: this.sku_item_code,
                    base_unit: this.base_unit,
                    secondary_unit: this.secondary_unit,
                    quantity: this.quantity,
                    free: this.free,
                    batch_no: this.batch_no,
                    product_availability: this.product_availability,
                    manufacturing_date: this.manufacturing_date,
                    expiry_date: this.expiry_date,
                    minimum_stock_alert: this.minimum_stock_alert,
                    location: this.location,
                    mrp: this.product_mrp,
                    sale_price: this.sale_price,
                    tax_type: this.tax_type,
                    purchase_price: this.purchase_price,
                    purchase_tax_type: this.purchase_tax_type,
                    tax_percentage: this.tax_percentage,
                    discount_type: this.discount_type,
                    discount_amount: this.discount_amount,
                    minimum_order_quantity: this.minimum_order_quantity,
                    description: this.product_description,
                    product_images: this.product_images,
                    secondary_unit_value: this.secondary_unit_value,
                    barcode: this.barcodeNumber
                }
                console.log("data", data)
                this.$store.dispatch('saveProduct', data)
                    .then((res) => {
                        switch (res.data.status) {
                            case 2:
                                this.valid = false;
                                this.sending = false;
                                this.$swal({
                                    icon: 'success',
                                    title: 'Congrats',
                                    text: 'Product added successfully',
                                });
                                this.$router.push('/list-product')
                                break;
                            case 3:
                                var error = ''
                                for (const prop in res.data.data) {
                                    error += res.data.data[prop]
                                }
                                this.$swal({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: `${error}`,
                                });
                                break;
                            default:
                                break;
                        }

                    })
                    .catch(err => {
                        console.log(err)
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `${err}`,
                        });
                    })
            },
            updateProduct() {
                let data = {
                    name: this.product_name,
                    category: this.product_category,
                    hsn_sac_code: this.hsn_sac_code,
                    sku_item_code: this.sku_item_code,
                    base_unit: this.base_unit,
                    secondary_unit: this.secondary_unit,
                    quantity: this.quantity,
                    free: this.free,
                    batch_no: this.batch_no,
                    product_availability: this.product_availability,
                    manufacturing_date: this.manufacturing_date,
                    expiry_date: this.expiry_date,
                    minimum_stock_alert: this.minimum_stock_alert,
                    location: this.location,
                    mrp: this.product_mrp,
                    sale_price: this.sale_price,
                    tax_type: this.tax_type,
                    purchase_price: this.purchase_price,
                    purchase_tax_type: this.purchase_tax_type,
                    tax_percentage: this.tax_percentage,
                    discount_type: this.discount_type,
                    discount_amount: this.discount_amount,
                    description: this.product_description,
                    minimum_order_quantity: this.minimum_order_quantity,
                    product_images: this.product_images,
                    id: this.$route.params.id,
                    selected_images: this.selected_images,
                    secondary_unit_value: this.secondary_unit_value,
                    barcode: this.barcodeNumber

                }
                this.$store.dispatch('updateProduct', data)
                    .then(() => {
                        //console.log(res)
                        this.$swal({
                            icon: 'success',
                            title: 'Congrats',
                            text: 'Product updated successfully',
                        });
                    })
                    .catch(err => {
                        // console.log(err)
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: err,
                        });
                    })
            },
            afterComplete(file) {
                this.product_images.push(file.dataURL)
                console.log("afterComplete", file.dataURL);
                console.log("afterComplete", file);
            },
            sub_category_change() {
                this.product_sub_categories.push(this.sub_category_input_val)
            },
            querySelections(v) {
                this.sub_category_input_val = v
            },
            addNewProductUnit() {
                this.products.push({
                    unit: '',
                    code: '',
                    mrp: '',
                    rate: '',
                    moq: 1,
                    available: '',
                    stock: ''
                })
            },
            removeProductUnit(index) {
                this.products.splice(index, 1)
            },
            onImageSelected(image) {
                var file = {
                    size: 200,
                    name: ''
                };
                this.selected_images.push(image)
                this.$refs.myVueDropzone.manuallyAddFile(file, image);

                //console.log(e)
            },
            // discountAmount() {
            //     if (this.discount_type == 'Amount') {
            //         this.minValue = 0
            //         this.maxValue = null
            //         this.discount_value_visible = true
            //         this.discount_type = 'Amount'
            //     } else if (this.discount_type == 'Percentage') {
            //         this.minValue = 0
            //         this.maxValue = 100
            //         this.discount_value_visible = true
            //         this.discount_type = 'Percentage'
            //     }
            // },
            getSelectedUnit({
                base_unit,
                secondary_unit,
                secondary_unit_value,
            }) {
                this.base_unit = base_unit
                this.secondary_unit = secondary_unit
                this.secondary_unit_value = secondary_unit_value
            },
            getBarcodeNumber({
                barcodeNumber,
                showInputForBarcodeNumber
            }) {
                this.barcodeNumber = barcodeNumber
                this.showInputForBarcodeNumber = showInputForBarcodeNumber
            },
            findNumber() {
                this.freeQuantity = [];
                this.totalFreeQuantity = 0;
                this.freeQuantity = this.free.match(/\d+/g) || [];
                // console.log("number",this.freeQuantity)
                for (let i = 0; i < this.freeQuantity.length; i++) {
                    this.totalFreeQuantity = parseInt(this.totalFreeQuantity) + parseInt(this.freeQuantity[i])
                }
                console.log("number", this.totalFreeQuantity)
            },
            salePriceCalculator() {
                if (this.sale_price != '') {

                    let tax_percentage = 0
                    if (this.tax_percentage == 'None') {
                        tax_percentage = 0;
                        this.taxPercentage = 'None'
                    } else if (this.tax_percentage == 'GST @ 0%') {
                        tax_percentage = 0;
                        this.taxPercentage = '0% GST'
                    } else if (this.tax_percentage == 'IGST @ 0%') {
                        tax_percentage = 0;
                        this.taxPercentage = '0% IGST'
                    } else if (this.tax_percentage == 'GST @ 0.25%') {
                        tax_percentage = 0.25 / 100;
                        this.taxPercentage = '0.25% GST'
                    } else if (this.tax_percentage == 'GST @ 12%') {
                        tax_percentage = 12 / 100;
                        this.taxPercentage = '12% GST'
                    } else if (this.tax_percentage == 'GST @ 18%') {
                        tax_percentage = 18 / 100;
                        this.taxPercentage = '18% GST'
                    }
                    if (this.tax_type == 'Excluding Tax') {
                        // this.final_price = parseFloat(this.sale_price) + parseFloat(tax_percentage) *
                        //             parseFloat(this.sale_price)
                        // this.final_price = this.final_price.toFixed(2)

                        this.taxAmount = parseFloat(tax_percentage) * parseFloat(this.sale_price)
                        this.taxAmount = this.taxAmount.toFixed(2)
                        this.salePriceWithoutTax = parseFloat(this.sale_price).toFixed(2)

                        this.final_price = parseFloat(this.salePriceWithoutTax) + parseFloat(this.taxAmount)
                        this.final_price = this.final_price.toFixed(2)
                    } else if (this.tax_type == 'Including Tax') {
                        this.taxAmount = parseFloat(tax_percentage) * parseFloat(this.sale_price)
                        this.taxAmount = this.taxAmount.toFixed(2)
                        this.salePriceWithoutTax = parseFloat(this.sale_price) - parseFloat(this.taxAmount)
                        this.salePriceWithoutTax = this.salePriceWithoutTax.toFixed(2)

                        this.final_price = parseFloat(this.salePriceWithoutTax) + parseFloat(this.taxAmount)
                        this.final_price = this.final_price.toFixed(2)
                    }
                }
            },
            showScanner() {
                this.showBarcodeScanner = true
                // this.showInputForBarcodeNumber=true
            },
            checkPurchasePrice() {
                if ( (this.sale_price!='') && (this.purchase_price!='') ) {
                    if (parseFloat(this.purchase_price) >= parseFloat(this.sale_price)) {
                        let text = "Are you sure your Purcase Price is more or equal to your Sale price ?";
                        if (confirm(text) == true) {
                            text = "You pressed OK!"
                        } else {
                            text = "You canceled!"
                            this.purchase_price=null
                        }
                    }
                }
            }

        },
        watch: {
            search(val) {
                val && val !== this.product_sub_category && this.querySelections(val)
                //console.log(val)
            },
        },
        created() {
            console.log("Product ID", this.$route.params.id)
            this.$store.dispatch('getPreferences')
                .then((res) => {
                    if (res.data.data) {
                        console.log("res", res.data.data)
                        this.preferences = res.data.data


                        // this.customer_type = this.preferences.customer_type
                        // this.visibility = this.preferences.visibility
                        this.product_stock_preference = this.preferences.SKU
                        if (this.preferences.product_code == 'yes') {
                            this.product_code_preference = true
                        } else {
                            this.product_code_preference = false
                        }
                        if (this.preferences.display_rate == 'yes') {
                            this.product_rate_preference = true
                        } else {
                            this.product_rate_preference = false
                        }

                        if (this.preferences.display_mrp == 'yes') {
                            this.product_mrp_preference = true
                        } else {
                            this.product_mrp_preference = false
                        }

                        // this.display_margin = this.preferences.display_margin
                        // this.general_info = this.preferences.general_info


                        // this.product_categories = this.preferences.categories
                        this.product_categories.push('None')
                        for (let i = 0; i < this.preferences.categories.length; i++) {
                            this.product_categories.push(this.preferences.categories[i])
                        }

                        // this.units = this.preferences.units
                        this.units.push('None')
                        for (let i = 0; i < this.preferences.units.length; i++) {
                            this.units.push(this.preferences.units[i])
                        }

                        // taxes from preference
                        this.taxesFromPreferences.push('None')
                        for (let i = 0; i < this.preferences.taxes.length; i++) {
                            this.taxesFromPreferences.push(this.preferences.taxes[i])
                        }
                        // taxes from preference

                        if (this.preferences.categories)
                            this.product_categories_input = true
                        console.log(this.preferences.categories)
                        if (this.units)
                            this.product_units_preference = true

                        if (this.preferences.opening_stock == 'yes') {
                            this.opening_stock = true
                        } else {
                            this.opening_stock = false
                        }

                        if (this.preferences.SKU == 'yes') {
                            this.product_sku_preference = true
                        } else {
                            this.product_sku_preference = false
                        }
                        if (this.preferences.barcode == 'yes') {
                            this.barcode = true
                        } else {
                            this.barcode = false
                        }

                        if (this.preferences.manufacturing_date == 'yes') {
                            this.manufacturing_date_preference = true
                        } else {
                            this.manufacturing_date_preference = false
                        }

                        if (this.preferences.expiry_date == 'yes') {
                            this.expiry_date_preference = true
                        } else {
                            this.expiry_date_preference = false
                        }

                        if (this.product_stock_preference == 'no' && this.product_code_preference == 'no' && this
                            .product_rate_preference == 'no' && this.product_mrp_preference == 'no') {
                            this.unit_inputbox_length = 6
                            this.moq_inputbox_length = 3
                        } else if (this.product_stock_preference == 'yes' && this.product_code_preference == 'no' &&
                            this.product_rate_preference == 'no' && this.product_mrp_preference == 'no') {
                            this.unit_inputbox_length = 5
                            this.moq_inputbox_length = 2
                        } else if (this.product_stock_preference == 'yes' && this.product_code_preference ==
                            'yes' && this.product_rate_preference == 'no' && this.product_mrp_preference == 'no') {
                            this.unit_inputbox_length = 4
                            this.moq_inputbox_length = 1
                        } else if (this.product_stock_preference == 'yes' && this.product_code_preference ==
                            'yes' && this.product_rate_preference == 'yes' && this.product_mrp_preference == 'no') {
                            this.unit_inputbox_length = 3
                            this.moq_inputbox_length = 1
                        } else if (this.product_stock_preference == 'yes' && this.product_code_preference ==
                            'yes' && this.product_rate_preference == 'no' && this.product_mrp_preference == 'no') {
                            this.unit_inputbox_length = 4
                            this.moq_inputbox_length = 1
                        } else if (this.product_stock_preference == 'no' && this.product_code_preference == 'no' &&
                            this.product_rate_preference == 'yes' && this.product_mrp_preference == 'yes') {
                            this.unit_inputbox_length = 5
                            this.moq_inputbox_length = 2
                        } else if (this.product_stock_preference == 'no' && this.product_code_preference == 'yes' &&
                            this.product_rate_preference == 'yes' && this.product_mrp_preference == 'yes') {
                            this.unit_inputbox_length = 4
                            this.moq_inputbox_length = 1
                        } else if (this.product_stock_preference == 'yes' && this.product_code_preference == 'no' &&
                            this.product_rate_preference == 'yes' && this.product_mrp_preference == 'yes') {
                            this.unit_inputbox_length = 4
                            this.moq_inputbox_length = 1
                        } else if (this.product_stock_preference == 'yes' && this.product_code_preference ==
                            'yes' && this.product_rate_preference == 'no' && this.product_mrp_preference == 'yes') {
                            this.unit_inputbox_length = 3
                            this.moq_inputbox_length = 1
                        } else if (this.product_stock_preference == 'no' && this.product_code_preference == 'yes' &&
                            this.product_rate_preference == 'no' && this.product_mrp_preference == 'yes') {
                            this.unit_inputbox_length = 4
                            this.moq_inputbox_length = 2
                        } else if (this.product_stock_preference == 'yes' && this.product_code_preference == 'no' &&
                            this.product_rate_preference == 'yes' && this.product_mrp_preference == 'no') {
                            this.unit_inputbox_length = 4
                            this.moq_inputbox_length = 2
                        }

                    }
                })
                .catch(err => {
                    console.log(err)
                })


            if (this.$route.params.id) {
                this.title = 'Edit Product'
                this.product_code_disabled = true
                this.save_btn = false
                this.update_btn = true
                this.$store.dispatch('getProduct', this.$route.params.id)
                    .then((res) => {
                        console.log("Product Data", res.data.data)
                        if (res.data.data) {
                            // console.log(res.data.data)
                            // this.product_category = res.data.data[0].category,
                            //     this.product_sub_category = res.data.data[0].sub_category,
                            //     this.product_name = res.data.data[0].name,
                            //     this.product_description = res.data.data[0].description,
                            //     this.tax = res.data.data[0].tax
                            // this.is_item_grouped = res.data.data[0].is_item_grouped
                            // if (res.data.data[0].is_item_grouped == 'yes')
                            //     this.add_unit_input = true
                            // else
                            //     this.add_unit_input = false
                            // if (res.data.data[0].tax)
                            //     this.tax_input = true

                            // PRODUCT PHOTO
                            for (let i = 0; i < res.data.data[0].photos.length; i++) {
                                var file = {
                                    size: 200,
                                    name: res.data.data[0].photos[i].photo_name
                                };
                                this.$refs.myVueDropzone.manuallyAddFile(file, res.data.data[0].photos[i]
                                    .photo_url);
                                // this.product_images[i] = res.data.data[0].photos[i].photo_url
                                // this.product_images.push(res.data.data[0].photos[i])
                                // this.afterComplete(res.data.data[0].photos[i].photo_url)
                                // console.log("Photo URL",res.data.data[0].photos[i].photo_url)

                                this.uploaded_product_images.push(res.data.data[0].photos[i].photo_url)

                            }
                            // PRODUCT PHOTO

                            // for (let i = 0; i < res.data.data[0].units.length; i++) {
                            //     this.products.push({
                            //         unit: res.data.data[0].units[i].units,
                            //         code: res.data.data[0].units[i].code,
                            //         mrp: res.data.data[0].units[i].mrp,
                            //         rate: res.data.data[0].units[i].rate,
                            //         moq: res.data.data[0].units[i].moq,
                            //         available: res.data.data[0].units[i].available,
                            //         stock: res.data.data[0].units[i].stock
                            //     })
                            // }

                            // UPDATED VALUE
                            this.product_name = res.data.data[0].name
                            this.product_category = res.data.data[0].category
                            this.hsn_sac_code = res.data.data[0].hsn_sac_code
                            this.sku_item_code = res.data.data[0].sku_item_code
                            this.base_unit = res.data.data[0].base_unit
                            this.secondary_unit = res.data.data[0].secondary_unit
                            this.secondary_unit_value = res.data.data[0].secondary_unit_value

                            this.quantity = res.data.data[0].quantity
                            this.free = res.data.data[0].free
                            this.batch_no = res.data.data[0].batch_no
                            this.product_availability = res.data.data[0].product_availability

                            this.manufacturing_date = res.data.data[0].manufacturing_date
                            this.expiry_date = res.data.data[0].expiry_date
                            this.minimum_stock_alert = res.data.data[0].minimum_stock_alert
                            this.location = res.data.data[0].location
                            this.product_mrp = res.data.data[0].mrp
                            this.sale_price = res.data.data[0].sale_price
                            this.tax_type = res.data.data[0].tax_type

                            this.purchase_price = res.data.data[0].purchase_price
                            this.purchase_tax_type = res.data.data[0].purchase_tax_type
                            this.tax_percentage = res.data.data[0].tax_percentage
                            this.discount_type = res.data.data[0].discount_type
                            this.discount_amount = res.data.data[0].discount_amount
                            this.product_description = res.data.data[0].description
                            this.minimum_order_quantity = res.data.data[0].minimum_order_quantity
                            this.barcodeNumber = res.data.data[0].barcode
                            // this.discountAmount()
                            this.salePriceCalculator()
                            // UPDATED VALUE
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        },
        mounted() {
            if (!this.$route.params.id)
                this.products.push(this.product)
        }
    }
</script>
<style>
    .heading {
        font-size: 20px !important;
        font-weight: bold !important;
    }

    .mandatory {
        color: red;
    }

    .subheading {
        font-weight: normal !important;
    }
</style>